class SizeGuideConversionNav extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()
    if (this.els.trigger) {
      this.els.trigger.elements.forEach(el =>
        this.listeners.add(
          el,
          'click',
          this.onPanelTriggerHandler.bind(this, event),
        ),
      )
    }
  }

  onPanelTriggerHandler () {
    const triggerKey = Number(
      event.target.dataset.sizeGuideConversionNavTriggerkey,
    )
    event.currentTarget.setAttribute('aria-expanded', true)
    event.currentTarget.setAttribute('aria-disabled', true)

    this.externalEls.guide.elements.forEach((panel, index) => {
      if (triggerKey === index) {
        panel.setAttribute('aria-hidden', false)
      } else {
        panel.setAttribute('aria-hidden', true)
      }
    })

    this.externalEls.title.elements.forEach((title, index) => {
      if (triggerKey === index) {
        title.style.display = 'inline-block'
      } else {
        title.setAttribute('aria-hidden', true)
        title.style.display = 'none'
      }
    })

    this.els.trigger.elements.forEach((trigger, index) => {
      if (triggerKey !== index) {
        trigger.setAttribute('aria-expanded', false)
        trigger.setAttribute('aria-disabled', false)
      }
    })
  }

  onPanelCloseHandler () {}
}

if (!customElements.get('size-guide-conversion-nav')) {
  customElements.define('size-guide-conversion-nav', SizeGuideConversionNav)
}
